// =========================================================================================@@
// Last Updated Date: Mar 29, 2022
// Last Updated By: Steven Yuen
// Status Level: 2
// ===========================================================================================

export default {
   tmpMainMenuBackgroundColor: '#0e1624',
   tmpMainMenuBorderColor: '#000',
   tmpMainMenuButtonActiveBackgroundColor: '#141d2e',
   tmpMainMenuButtonTextColor: '#d0dce3',
   headerMainMenuTextSize: '2',
   tmpTitleSmSize: '3',
   tmpHeaderHeight: '70px[a-b] 75px[c-f]',
   tmpViewportHeight: `
      calc(100vh - 70px)[a-b]
      calc(100vh - 75px)[c-f]
   `,
   tmpContentFixedAreaHeight: `
      calc(100vh - 70px)[a-b]
      calc(100vh - 75px)[c-f]
   `,
   viewportMarginTop: '70px[a-b] 75px[c-f]',
   tmpViewportPadding: '20px[a] 20px[b] 30px[c] 30px[d] 40px[e] calc(50vw - 850px + 100px)[f]',
   tmpViewportPaddingE: '40px',
   tmpViewportPaddingF: 'calc(50vw - 850px + 100px)'
}
